import Mentions from './Mentions';
export default Mentions;


//////////////////
// WEBPACK FOOTER
// ./~/rc-mentions/es/index.js
// module id = 1496
// module chunks = 3